// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13tKV","col":"styles_col__2uoRs"};